/**
 * 猜你喜欢
 * 
 * @Author: Focci
 * @Date: 2023-08-05 16:25:49
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-05 16:25:49
 */

'use client'

// import PropTypes from 'prop-types'
import useFetch from '@hook/useFetch'
import { houseSearchType, typeIds } from '@lib/config'
import { useMemo, useState } from 'react'
import { useTranslations } from 'next-intl'
import { isArray } from 'lodash-es'
import { Waypoint } from 'react-waypoint'
import ListingCard from '../../listing/ListingCard'
import ListingGrid from '../../listing/ListingGrid'

export function GuessYouLikeGrid({
  type,
  wrapperClassName,
  children = () => {},
  customProps
}) {
  const [enter, setEnter] = useState(false)

  // 买房、租房、商业地产传对应的 typeId值
  // 其它的传 0
  const typeId = [
    houseSearchType.residential,
    houseSearchType.rental,
  ].indexOf(type) > -1
    ? typeIds[type] || 0
    : 0
  
  const fetchParam = { 
    tag: '猜您喜欢', 
    typeId, 
    limit: 4 
  }

  const url = enter ? 'waterfall-listings' : null
  const { data, isLoading } = useFetch(url, fetchParam)

  const listings = useMemo(() => {
    if(!isArray(data)) return []
    return data.map((item) => {
      const tmp = item.data_type === 'ad'
        ? { ...item, is_ad: true }
        : { ...item[item.data_type], is_feature: false }

      return tmp
    })
  }, [data])

  return (
    <Waypoint onEnter={() => setEnter(true)}>
      <div>
        <ListingGrid
          loadingCount={4}
          isLoading={isLoading || !enter} 
          enter={enter} 
          wrapperClassName={wrapperClassName}
        >
          {listings.map((item) => (
            <ListingCard
              key={item.id} 
              house={{ ...item, customProps }}
            />
          ))}
          {children({ data: listings })}
        </ListingGrid>
      </div>
    </Waypoint>
  )
}

export default function GuessYouLike({
  type,
  wrapperClassName
}) {
  const ts = useTranslations('search')
  return (
    <div>
      <div className="text-f.9 font-medium">
        {ts('guessYouLike')}
      </div>

      <GuessYouLikeGrid type={type} wrapperClassName={wrapperClassName} />
    </div>
  )
}

// GuessYouLike.propTypes = {
//   wrapperClassName: PropTypes.string,
// }
